import gql from 'graphql-tag';

/**
 * Award the credentials/rewards an activity completion earns - the Nexus home of the merit
 * write, replacing the legacy student-service `POST /badges` Lambda. Returns the same
 * `{ message, data }` JSON the Lambda did: `data` is the user document on a real award and
 * `null` on a no-op (already awarded, unknown activity, flag off) - the callers gate the
 * "Badge earned" snackbar on a truthy `data`, so a repeat completion stays silent.
 */
export const AWARD_ACTIVITY_MERITS_MUTATION = gql`
  mutation AwardActivityMerits($studentId: String!, $adkName: String!) {
    awardActivityMerits(studentId: $studentId, adkName: $adkName)
  }
`;
